// Default prop values for TaskListBase
export const TASK_LIST_BASE_DEFAULTS = {
  id: null,
  isSortable: false,
  editingTaskId: null,
  onStartEditing: () => {},
  onStopEditing: () => {},
  selectedTaskIds: [],
  onSelectionChange: () => {},
  selectNewTask: false,
  indentationType: 'none',
  plannedParentIds: new Set(),
  waitingForParentIds: new Set(),
  view: 'default',
  showBreadcrumbs: false,
  onBeforeToggleComplete: () => {},
  topActionableTaskId: null,
  showPlayButtonAlways: false,
  dragEnabled: false,
  disableStructuralNav: false,
  listTabIndex: 0,
  itemTabIndex: undefined,
  disableRowNavigate: false,
  listId: null,
  focusOwnerId: null,
  addSubtaskOnParentsOnly: false,
  menuSurface: null,
  dragType: null,
  planMode: false,
  onboardingHighlightTaskId: null,
};
